/* see https://github.com/facebookincubator/create-react-app/blob/master/config/polyfills.js */
if (typeof Promise === 'undefined') {
  require('promise/lib/rejection-tracking').enable()
  window.Promise = require('promise/lib/es6-extensions.js')
}

require('whatwg-fetch')



/*****************
 ** WEBPACK FOOTER
 ** ../indoqa-webpack/src/polyfills.js
 ** module id = 303
 ** module chunks = 0
 **/